import createPaymentIntent from './create-payment-intent';
import collectPayment from './collect-payment';

export default {
	createPaymentIntent,
	collectPayment
};
